// Explicit synthetic preview data. Never used as component defaults.
import React from 'react';
import { ART_BASE } from '../assets.js';
const ASSET = ART_BASE;

export const FIXTURE_PENDING = {
  amount: 1.25,
  caption: 'is waiting for high-fives',
  description:
    'Two lanterns you lit are on their way to Mom and Dad — the coins hop in right after. ✦',
};

export const FIXTURE_JARS = [
  { id: 'save', name: 'Save', kind: 'save', amount: 3.5, level: 56 },
  { id: 'share', name: 'Share', kind: 'share', amount: 0.75, level: 12 },
  { id: 'spend', name: 'Spend', kind: 'spend', amount: 2.0, level: 32 },
];

export const FIXTURE_GOAL = {
  title: 'LEGO Lighthouse Rescue set',
  subtitle: 'your quest beyond the village — picked with Mom',
  saved: 6.25,
  goal: 20,
  weeksLeft: 4,
  imageSrc: `${ASSET}/spot-trophy.png`,
};

export const FIXTURE_CHAPTERS = [
  {
    id: 'ch-12',
    chapter: 12,
    date: 'Friday Jun 5',
    earned: 8.5,
    story: 'Your brightest week yet — you earned $8.50 and the whole village glowed.',
    chips: [
      { kind: 'gold', label: '11 quests lit' },
      { kind: 'ember', label: 'biggest: Walk Biscuit · $1.00' },
      { kind: 'violet', label: '+165 XP' },
    ],
    latest: true,
  },
  {
    id: 'ch-11',
    chapter: 11,
    date: 'Friday May 29',
    earned: 6.75,
    story: 'You earned $6.75 — rain all week, but your lanterns stayed lit.',
    chips: [
      { kind: 'gold', label: '9 quests lit' },
      { kind: 'ember', label: 'biggest: Fold the laundry · $1.25' },
      { kind: 'violet', label: '+135 XP' },
    ],
  },
  {
    id: 'ch-10',
    chapter: 10,
    date: 'Friday May 22',
    earned: 7.25,
    story: 'You earned $7.25 and started your Save jar for the lighthouse.',
    chips: [
      { kind: 'gold', label: '10 quests lit' },
      { kind: 'ember', label: 'biggest: Unload the dishwasher · $0.75' },
      { kind: 'violet', label: '+150 XP' },
    ],
  },
];

export const FIXTURE_SPLIT_NOTE = (
  <>
    Mom and Dad set your jars: <b className="num">50 / 10 / 40</b> — every payday splits itself.
  </>
);

export const walletFixture = {
  pending: FIXTURE_PENDING,
  jars: FIXTURE_JARS,
  goal: FIXTURE_GOAL,
  chapters: FIXTURE_CHAPTERS,
  jarsSplitNote: FIXTURE_SPLIT_NOTE,
  kidName: 'Maya',
  streak: 3,
  avatar: `${ASSET}/avatar-kid-1.jpg`,
  balance: 6.25,
  nextChapter: { label: 'Chapter 13 arrives Friday' },
};
